import { Component } from '@angular/core';
import { Events, ModalController } from 'ionic-angular';
import { DataServiceProvider } from '../../providers/data-service/data-service';
import { ExportServiceProvider } from '../../providers/export-service/export-service';
import { PriceListTableProvider } from '../../providers/price-list-table/price-list-table';

declare var require: any
var pmt = require('formula-pmt');

const DEFAULTVALUE = 0;
@Component({
  selector: 'hardware-software-sheet',
  templateUrl: 'hardware-software-sheet.html'
})
export class HardwareSoftwareSheetComponent {
  headerValues = {
    buttonLabel: [{
      "name": "return",
      "action": 'return'
    }, {
      "name": "price list",
      "action": 'priceList'
    },{
      "name": "preview",
      "action": 'preview'
    }]
  };
  newContractLineItems: any ;
  lastMonthupfront: any = 'yes';
  month=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  showLease: boolean = true;
  showPurchase: boolean = true;
  constructor(public dataService: DataServiceProvider,public priceListTableService : PriceListTableProvider,public modalCtrl: ModalController,public exportService: ExportServiceProvider, public event: Events) {
    this.newContractLineItems = JSON.stringify({
      "qty":"",
      "description":"",
      "unitCost":"",
      "orMarkup":"",
      "unitPrice":"",
      "extendedPrice":"",
      "monthlyLeaseAmt":"",
      "totalLeaseRevenue":"",
      "totalLeaseCost":"",
      "totalLeaseProfit":""
    });
  }

  ngOnInit(){
    this.dataService.goBack = 'HW';
    this.dataService.sheetName = 'HW';
    this.dataService.broadcastInfo({ src: 'proposal-create', event: 'PAGE_HEADER', status: true, params: this.headerValues});
    if(localStorage.getItem('HWSWScreenData')){
      this.dataService.ProposalTable.hwswHaasSaasSheet = JSON.parse(localStorage.getItem('HWSWScreenData'));
      if( this.dataService.ProposalTable.hwswHaasSaasSheet.leaseOrPurchase == 'purchase'){
        this.showPurchase = true;
        this.showLease = false;
      }else if( this.dataService.ProposalTable.hwswHaasSaasSheet.leaseOrPurchase == 'lease'){
        this.showPurchase = false;
        this.showLease = true;
      }else{
        this.showPurchase = true;
        this.showLease = true;
      }
    }
    this.ofDuration();
    this.dataService.broadcastInfo({ src: 'proposal-create', event: 'PAGE_HEADER_VALUE', params: ''});
  }
  ngAfterViewInit(){
    if(localStorage.getItem('MSPForm')){
      let formVal = JSON.parse(localStorage.getItem('MSPForm'));
      var newDate = new Date(formVal.startDate);
      this.dataService.ProposalTable.hwswHaasSaasSheet.firstInvDate =  newDate.getDate() + '-' + this.month[newDate.getMonth()] + '-' + newDate.getFullYear().toString().slice(-2);
      this.lastinvDate();
    }
     document.getElementById('pageWidth').scrollIntoView();
  }
  ngAfterViewChecked(){
    localStorage.setItem('HWSWScreenData', JSON.stringify(this.dataService.ProposalTable.hwswHaasSaasSheet));
  }
  description(event,i){
      this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].description = event.target.value;
  }
  leaseOrPurchase(event){
    if(event.target.value == 'purchase'){
      this.showPurchase = true;
      this.showLease = false;
      setTimeout(() => {
      document.getElementById('TotalExtendedPrice').style.backgroundColor = '#fdff00';
      document.getElementById('ProductProfit1').style.backgroundColor = '#fdff00';
    }, 100);
      this.dataService.ProposalTable.hwswHaasSaasSheet.leaseOrPurchaseDescription = 'For purchase of Hardware and software and related services (if applicable) as outlined in the table below.'
    }else if(event.target.value == 'lease'){
      this.showPurchase = false;
      this.showLease = true;
      setTimeout(() => {
      document.getElementById('firstLastMnthPmt').style.backgroundColor = '#fdff00';
      document.getElementById('ProductProfit2').style.backgroundColor = '#fdff00';
      document.getElementById('TotalMonthlyLeaseAmt').style.backgroundColor = '#fdff00';
      document.getElementById('interestProfit').style.backgroundColor = '#fdff00';
      }, 100);
      this.dataService.ProposalTable.hwswHaasSaasSheet.leaseOrPurchaseDescription = 'For lease of Hardware and software and related services (if applicable) as outlined in the table below.'
    }else{
      this.showPurchase = true;
      this.showLease = true;
      setTimeout(() => {
      document.getElementById('TotalExtendedPrice').style.backgroundColor = '#f2f2f2';
      document.getElementById('ProductProfit1').style.backgroundColor = '#f2f2f2';
      document.getElementById('firstLastMnthPmt').style.backgroundColor = '#f2f2f2';
      document.getElementById('ProductProfit2').style.backgroundColor = '#f2f2f2';
      document.getElementById('TotalMonthlyLeaseAmt').style.backgroundColor = '#f2f2f2';
      document.getElementById('interestProfit').style.backgroundColor = '#f2f2f2';
    }, 100);
      this.dataService.ProposalTable.hwswHaasSaasSheet.leaseOrPurchaseDescription = 'For purchase of Hardware and software and related services (if applicable) as outlined in the table below.'
    }
  }
  orMarkup(event,i){
    if (event.target.value != '') {
      if (event.target.value.includes("%") == true) {
        this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].orMarkup = parseFloat(event.target.value.slice(0, -1)) + '%';
      } else {
        this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].orMarkup = parseFloat(event.target.value) + '%';
      }
      if(this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].unitCost != ''){
        var untPrice = (parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].unitCost.slice(1).replace(/  |,/gi,"")) * (1 + (parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].orMarkup.slice(0, -1)) / 100)));
        this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].unitPrice = '$' + untPrice.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        if(this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].qty != ""){
          this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].extendedPrice = '$' + (parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].qty) * untPrice).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
          this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].totalLeaseCost = '$' + (parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].unitCost.slice(1).replace(/  |,/gi,"")) * parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].qty)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        }else{
          this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].extendedPrice = '';
          this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].totalLeaseCost = '';
        }
      }
} else {
      this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].orMarkup = '';
    }
    this.TotalExtendedPrice();
    this.LeaseAmtCalculation(i);
    this.TotalMonthlyLeaseAmt();
    this.TotalLeaseRevenue();
    this.TotalLeaseCost();
    this.TotalLeaseProfit();
    this.ProfitCalucation();
  }
  qty(event,i){
    this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].qty = event.target.value;
    if(this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].qty != ""){
      if(this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].unitCost != ''){
        if(this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].orMarkup != ''){
          var untPrice = (parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].unitCost.slice(1).replace(/  |,/gi,"")) * (1 + (parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].orMarkup.slice(0, -1)) / 100)));
        }else{
          var untPrice = (parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].unitCost.slice(1).replace(/  |,/gi,"")) * (1 + (parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.markUp.slice(0, -1)) / 100)));
        }
        this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].unitPrice = '$' + untPrice.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].extendedPrice = '$' + (parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].qty) * untPrice).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].totalLeaseCost = '$' + (parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].unitCost.slice(1).replace(/  |,/gi,"")) * parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].qty)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }
    this.TotalExtendedPrice();
    this.LeaseAmtCalculation(i);
    this.TotalMonthlyLeaseAmt();
    this.TotalLeaseRevenue();
    this.TotalLeaseCost();
    this.TotalLeaseProfit();
    this.ProfitCalucation();
    }else{
      this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].qty = '';
      this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].extendedPrice = '';
      this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].totalLeaseCost = '';
      this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].monthlyLeaseAmt = '';
      this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].totalLeaseRevenue = '';
      this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].totalLeaseProfit = '';
      this.TotalExtendedPrice();
      this.TotalMonthlyLeaseAmt();
      this.TotalLeaseRevenue();
      this.TotalLeaseCost();
      this.TotalLeaseProfit();
      this.ProfitCalucation();
    }
  }
  LeaseAmtCalculation(idx){
    if(this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[idx].unitPrice != ''){
      if(this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[idx].qty != ''){
        let monthlyLeaseAmt =  this.PmtCalculate(this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[idx].unitPrice, this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[idx].qty);
        this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[idx].monthlyLeaseAmt = '$' + monthlyLeaseAmt.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[idx].totalLeaseRevenue = '$' + (parseFloat(monthlyLeaseAmt) * parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.Months)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[idx].totalLeaseProfit = '$' + (parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[idx].totalLeaseRevenue.slice(1).replace(/  |,/gi,"")) - parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[idx].totalLeaseCost.slice(1).replace(/  |,/gi,""))).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }else{
        this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[idx].monthlyLeaseAmt = '';
        this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[idx].totalLeaseRevenue = '';
        this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[idx].totalLeaseProfit = '';
      }
    }
  }
  ProfitCalucation(){
    this.dataService.ProposalTable.hwswHaasSaasSheet.ProductProfit = '$' + (parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.TotalExtendedPrice.slice(1).replace(/  |,/gi,"")) - parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.TotalLeastCost.slice(1).replace(/  |,/gi,""))).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    let perVal = (parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.ProductProfit.slice(1).replace(/  |,/gi,"")) / parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.TotalLeaseProfit.slice(1).replace(/  |,/gi,""))).toFixed(2);
    let prftPercnt = (parseFloat(perVal) * 100).toFixed().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    if(prftPercnt != 'NaN'){
      this.dataService.ProposalTable.hwswHaasSaasSheet.profitPercent = Math.floor(parseFloat(prftPercnt)) + '%';
      this.dataService.ProposalTable.hwswHaasSaasSheet.interestProfit = '$' + (parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.TotalLeaseProfit.slice(1).replace(/  |,/gi,"")) - parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.ProductProfit.slice(1).replace(/  |,/gi,""))).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }else{
      this.dataService.ProposalTable.hwswHaasSaasSheet.profitPercent = '';
      this.dataService.ProposalTable.hwswHaasSaasSheet.interestProfit = '';
    }
    
    let perVals = (parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.interestProfit.slice(1).replace(/  |,/gi,"")) / parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.TotalLeaseProfit.slice(1).replace(/  |,/gi,""))).toFixed(2);
    let intrstPercnt = (parseFloat(perVals) * 100).toFixed();
    if(intrstPercnt != 'NaN'){
      this.dataService.ProposalTable.hwswHaasSaasSheet.interestPercent = Math.floor(parseFloat(intrstPercnt)) + '%';
    }else{
      this.dataService.ProposalTable.hwswHaasSaasSheet.interestPercent = '';
    }
    
    
  }
  unitCost(event,i){
    if(event.target.value != ''){
      var unitcost;
      if (event.target.value.includes("$") == true) {
        unitcost = parseFloat(event.target.value.slice(1).replace(/  |,/gi,""));
      }else{
        unitcost = parseFloat(event.target.value);
      }
      this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].unitCost = '$' + unitcost.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      if(this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].orMarkup != ''){
        var untPrice = (parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].unitCost.slice(1).replace(/  |,/gi,"")) * (1 + (parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].orMarkup.slice(0, -1)) / 100)));
      }else{
        var untPrice = (parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].unitCost.slice(1).replace(/  |,/gi,"")) * (1 + (parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.markUp.slice(0, -1)) / 100)));
      }
      this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].unitPrice = '$' + untPrice.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      if(this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].qty != ''){
        this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].extendedPrice = '$' + (parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].qty) * untPrice).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].totalLeaseCost = '$' + (parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].unitCost.slice(1).replace(/  |,/gi,"")) * parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].qty)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }else{
        this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].extendedPrice = '';
        this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].totalLeaseCost = '';
      }
    }else{
        this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].unitCost = '';
        this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].unitPrice = '';
        this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].extendedPrice = '';
        this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].totalLeaseCost = '';
        this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].monthlyLeaseAmt = '';
        this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].totalLeaseRevenue = '';
        this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems[i].totalLeaseProfit = '';
    }
    this.TotalExtendedPrice();
    this.LeaseAmtCalculation(i);
    this.TotalMonthlyLeaseAmt();
    this.TotalLeaseRevenue();
    this.TotalLeaseCost();
    this.TotalLeaseProfit();
    this.ProfitCalucation();
  }
  markup(event){
    let val = event.target.value.charAt(event.target.value.length - 1);
    if (event.target.value != '' && val != '%') {
      this.dataService.ProposalTable.hwswHaasSaasSheet.markUp =  event.target.value.concat("%");
    } else {
      this.dataService.ProposalTable.hwswHaasSaasSheet.markUp = event.target.value;
    }
    this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems.forEach(elem=>{
      if(elem.orMarkup == '' && elem.unitCost != '' && elem.qty != ''){
        var untPrice = (parseFloat(elem.unitCost.slice(1).replace(/  |,/gi,"")) * (1 + (parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.markUp.slice(0, -1)) / 100)));
        elem.unitPrice = '$' + untPrice.toFixed(2);
        elem.extendedPrice = '$' + (parseFloat(elem.qty) * untPrice).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        elem.totalLeaseCost = '$' + (parseFloat(elem.unitCost.slice(1).replace(/  |,/gi,"")) * parseFloat(elem.qty)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        let monthlyLeaseAmt =  this.PmtCalculate(elem.unitPrice,elem.qty);
        elem.monthlyLeaseAmt = '$' + monthlyLeaseAmt.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        elem.totalLeaseRevenue = '$' + (parseFloat(monthlyLeaseAmt) * parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.Months)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        elem.totalLeaseProfit = '$' + (parseFloat(elem.totalLeaseRevenue.slice(1).replace(/  |,/gi,"")) - parseFloat(elem.totalLeaseCost.slice(1).replace(/  |,/gi,""))).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }
    });
    this.TotalExtendedPrice();
    this.TotalMonthlyLeaseAmt();
    this.TotalLeaseRevenue();
    this.TotalLeaseCost();
    this.TotalLeaseProfit();
    this.ProfitCalucation();
  }
  TotalExtendedPrice(){
    let sumArray = [];
    this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems.forEach(elem => {
      if (elem.extendedPrice == '') {
        var totalval = DEFAULTVALUE
      } else {
        totalval = parseFloat(elem.extendedPrice.slice(1).replace(/  |,/gi,""));
      }
      sumArray.push(totalval)
    })
    var value = sumArray.reduce(function (a, b) {
      return a + b;
    }, 0);
    if(value != DEFAULTVALUE){
      this.dataService.ProposalTable.hwswHaasSaasSheet.TotalExtendedPrice = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }else{
      this.dataService.ProposalTable.hwswHaasSaasSheet.TotalExtendedPrice = '';
    }
  }
  TotalLeaseCost(){
    let sumArray = [];
    this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems.forEach(elem => {
      if (elem.totalLeaseCost == '') {
        var totalval = DEFAULTVALUE
      } else {
        totalval = parseFloat(elem.totalLeaseCost.slice(1).replace(/  |,/gi,""));
      }
      sumArray.push(totalval)
    })
    var value = sumArray.reduce(function (a, b) {
      return a + b;
    }, 0);
    if(value != DEFAULTVALUE){
    this.dataService.ProposalTable.hwswHaasSaasSheet.TotalLeastCost = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }else{
    this.dataService.ProposalTable.hwswHaasSaasSheet.TotalLeastCost = '';
  }
  }
  TotalLeaseProfit(){
    let sumArray = [];
    this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems.forEach(elem => {
      if (elem.totalLeaseProfit == '') {
        var totalval = DEFAULTVALUE
      } else {
        totalval = parseFloat(elem.totalLeaseProfit.slice(1).replace(/  |,/gi,""));
      }
      sumArray.push(totalval)
    })
    var value = sumArray.reduce(function (a, b) {
      return a + b;
    }, 0);
    if(value != DEFAULTVALUE){
    this.dataService.ProposalTable.hwswHaasSaasSheet.TotalLeaseProfit = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }else{
  this.dataService.ProposalTable.hwswHaasSaasSheet.TotalLeaseProfit = '';
}
  }
  TotalMonthlyLeaseAmt(){
    let sumArray = [];
    this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems.forEach(elem => {
      if (elem.monthlyLeaseAmt == '') {
        var totalval = DEFAULTVALUE
      } else {
        totalval = parseFloat(elem.monthlyLeaseAmt.slice(1).replace(/  |,/gi,""));
      }
      sumArray.push(totalval)
    })
    var value = sumArray.reduce(function (a, b) {
      return a + b;
    }, 0);
    if(value != DEFAULTVALUE){
    this.dataService.ProposalTable.hwswHaasSaasSheet.TotalMonthlyLeaseAmt = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }else{
  this.dataService.ProposalTable.hwswHaasSaasSheet.TotalMonthlyLeaseAmt = '';
}
    if(this.lastMonthupfront.toUpperCase() == 'YES'){
     this.dataService.ProposalTable.hwswHaasSaasSheet.firstLastMnthPmt = '$' + (parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.TotalMonthlyLeaseAmt.slice(1).replace(/  |,/gi,"")) * 2).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
     }else{
      this.dataService.ProposalTable.hwswHaasSaasSheet.firstLastMnthPmt = this.dataService.ProposalTable.hwswHaasSaasSheet.TotalMonthlyLeaseAmt
     }
  }
  lastMonthUpfront(event){
    this.ofDuration();
    this.TotalExtendedPrice();
    this.TotalMonthlyLeaseAmt();
    this.TotalLeaseRevenue();
    this.TotalLeaseCost();
    this.TotalLeaseProfit();
    this.ProfitCalucation();
    this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems.forEach(elem=>{
      if(elem.orMarkup == '' && elem.unitCost != '' && elem.qty != ''){
        var untPrice = (parseFloat(elem.unitCost.slice(1).replace(/  |,/gi,"")) * (1 + (parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.markUp.slice(0, -1)) / 100)));
        elem.unitPrice = '$' + untPrice.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        elem.extendedPrice = '$' + (parseFloat(elem.qty) * untPrice).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        elem.totalLeaseCost = '$' + (parseFloat(elem.unitCost.slice(1).replace(/  |,/gi,"")) * parseFloat(elem.qty)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        let monthlyLeaseAmt =  this.PmtCalculate(elem.unitPrice,elem.qty);
        elem.monthlyLeaseAmt = '$' + monthlyLeaseAmt.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        elem.totalLeaseRevenue = '$' + (parseFloat(monthlyLeaseAmt) * parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.Months)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        elem.totalLeaseProfit = '$' + (parseFloat(elem.totalLeaseRevenue.slice(1).replace(/  |,/gi,"")) - parseFloat(elem.totalLeaseCost.slice(1).replace(/  |,/gi,""))).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }
    });
  }
  months(event){
   this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems.forEach(elem=>{
    if(elem.orMarkup == '' && elem.unitCost != '' && elem.qty != ''){
      var untPrice = (parseFloat(elem.unitCost.slice(1).replace(/  |,/gi,"")) * (1 + (parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.markUp.slice(0, -1)) / 100)));
      elem.unitPrice = '$' + untPrice.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      elem.extendedPrice = '$' + (parseFloat(elem.qty) * untPrice).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      elem.totalLeaseCost = '$' + (parseFloat(elem.unitCost.slice(1).replace(/  |,/gi,"")) * parseFloat(elem.qty)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      let monthlyLeaseAmt =  this.PmtCalculate(elem.unitPrice, elem.qty);
      elem.monthlyLeaseAmt = '$' + monthlyLeaseAmt.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      elem.totalLeaseRevenue = '$' + (parseFloat(monthlyLeaseAmt) * parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.Months)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      elem.totalLeaseProfit = '$' + (parseFloat(elem.totalLeaseRevenue.slice(1).replace(/  |,/gi,"")) - parseFloat(elem.totalLeaseCost.slice(1).replace(/  |,/gi,""))).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }
  });
  this.ofDuration();
  this.TotalExtendedPrice();
  this.TotalMonthlyLeaseAmt();
  this.TotalLeaseRevenue();
  this.TotalLeaseCost();
  this.TotalLeaseProfit();
  this.ProfitCalucation();
  }
  ofDuration(){
    if(this.lastMonthupfront.toUpperCase() == 'YES'){
     if(this.dataService.ProposalTable.hwswHaasSaasSheet.Months == '1' || this.dataService.ProposalTable.hwswHaasSaasSheet.Months == DEFAULTVALUE.toString()){
      this.dataService.ProposalTable.hwswHaasSaasSheet.nextMonth = DEFAULTVALUE.toString();
      this.dataService.ProposalTable.hwswHaasSaasSheet.OfDuration = '';
     }else{
      this.dataService.ProposalTable.hwswHaasSaasSheet.OfDuration = this.dataService.ProposalTable.hwswHaasSaasSheet.Months != '' ? (parseInt(this.dataService.ProposalTable.hwswHaasSaasSheet.Months) - 1).toString() : '';
      this.dataService.ProposalTable.hwswHaasSaasSheet.nextMonth = this.dataService.ProposalTable.hwswHaasSaasSheet.Months != '' ? (parseInt(this.dataService.ProposalTable.hwswHaasSaasSheet.Months) - 1).toString() : DEFAULTVALUE.toString();
     }
    }else{
      this.dataService.ProposalTable.hwswHaasSaasSheet.OfDuration = this.dataService.ProposalTable.hwswHaasSaasSheet.Months != '' ? this.dataService.ProposalTable.hwswHaasSaasSheet.Months : '';
      this.dataService.ProposalTable.hwswHaasSaasSheet.nextMonth = this.dataService.ProposalTable.hwswHaasSaasSheet.Months != '' ? this.dataService.ProposalTable.hwswHaasSaasSheet.Months : '';
    }
    if(this.dataService.ProposalTable.hwswHaasSaasSheet.OfDuration == ''){
      this.dataService.ProposalTable.hwswHaasSaasSheet.nextMonth = DEFAULTVALUE.toString();
    }
    this.lastinvDate();
  }
  lastinvDate(){
    var newDate = new Date(this.dataService.ProposalTable.hwswHaasSaasSheet.firstInvDate);
      newDate.setMonth(newDate.getMonth() + (parseInt(this.dataService.ProposalTable.hwswHaasSaasSheet.nextMonth) - 1));
      this.dataService.ProposalTable.hwswHaasSaasSheet.lastInvDate =  " 01-" + this.month[newDate.getMonth()] + '-' + newDate.getFullYear().toString().slice(-2);
  }
  PmtCalculate(unitprice, qty){
    let intrstRt = this.dataService.ProposalTable.hwswHaasSaasSheet.interestRate != '' ? parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.interestRate.slice(0, -1)) / 100 : DEFAULTVALUE;
    let mnths = this.dataService.ProposalTable.hwswHaasSaasSheet.Months != '' ? parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.Months) : DEFAULTVALUE;
    var val = pmt( intrstRt / 12, mnths, parseFloat(unitprice.slice(1).replace(/  |,/gi,"")));
    let value = parseFloat((val * -1).toString()).toFixed(2);
    return ( parseFloat(value) * parseFloat(qty)).toFixed(2);
  }
  interestRate(event){
    if(event.target.value != ''){
      if (event.target.value.includes("%") == true) {
        this.dataService.ProposalTable.hwswHaasSaasSheet.interestRate = event.target.value;
      }else{
        this.dataService.ProposalTable.hwswHaasSaasSheet.interestRate = event.target.value + '%';
      }
    }else{
      this.dataService.ProposalTable.hwswHaasSaasSheet.interestRate = ''
    }
    this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems.forEach(elem=>{
      if(elem.unitCost != '' && elem.qty != ''){
        let monthlyLeaseAmt =  this.PmtCalculate(elem.unitPrice, elem.qty);
        elem.monthlyLeaseAmt = '$' + monthlyLeaseAmt.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        elem.totalLeaseRevenue = '$' + (parseFloat(monthlyLeaseAmt) * parseFloat(this.dataService.ProposalTable.hwswHaasSaasSheet.Months)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        elem.totalLeaseProfit = '$' + (parseFloat(elem.totalLeaseRevenue.slice(1).replace(/  |,/gi,"")) - parseFloat(elem.totalLeaseCost.slice(1).replace(/  |,/gi,""))).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }
    });
    this.TotalExtendedPrice();
    this.TotalMonthlyLeaseAmt();
    this.TotalLeaseRevenue();
    this.TotalLeaseCost();
    this.TotalLeaseProfit();
    this.ProfitCalucation();
  }
  TotalLeaseRevenue(){
    let sumArray = [];
    this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems.forEach(elem => {
      if (elem.totalLeaseRevenue == '') {
        var totalval = DEFAULTVALUE
      } else {
        totalval = parseFloat(elem.totalLeaseRevenue.slice(1).replace(/  |,/gi,""));
      }
      sumArray.push(totalval)
    })
    var value = sumArray.reduce(function (a, b) {
      return a + b;
    }, 0);
    if(value != DEFAULTVALUE){
      this.dataService.ProposalTable.hwswHaasSaasSheet.TotalLeaseRevenue = '$' + value.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }else{
      this.dataService.ProposalTable.hwswHaasSaasSheet.TotalLeaseRevenue = '';
    }
  }
  addRow() {
    let newRow = JSON.parse(this.newContractLineItems);
    this.dataService.ProposalTable.hwswHaasSaasSheet.contractLineItems.push(newRow)
  }
  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// ./src/components/hardware-software-sheet/hardware-software-sheet.ts